module.exports = __webpack_public_path__ + "static/img/pic_home_zijin.337fc9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/pic_home_zijin.png
// module id = xEgu
// module chunks = 83